import { Button, Card, CardContent } from '@crm/ui';
import { UserCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Quando o e-mail do CTA ja tem cadastro (ou a sessao ja terminou o wizard).
 * Nao reabre o wizard - so aponta para onde a pessoa deve entrar.
 */
export function AlreadyRegisteredNotice({ to, actionLabel }: { to: string; actionLabel: string }) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <UserCheck className="h-6 w-6" />
        </span>
        <h1 className="text-lg font-semibold">Voce ja tem cadastro</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          Este e-mail ou WhatsApp já está cadastrado no sistema. Entre com a sua conta para
          continuar.
        </p>
        <Button asChild className="mt-2">
          <Link to={to}>{actionLabel}</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
